import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import type { ViewPaneHeaderProps } from 'appLayout/ardoqStudio/types';
import { ConnectedViewPaneHeaderLeftControls as ViewPaneHeaderLeftControls } from './ViewPaneHeaderLeftControls';
import { ConnectedViewPaneHeaderRightControls as ViewPaneHeaderRightControls } from './ViewPaneHeaderRightControls';
import { viewPaneHeader$ } from 'appLayout/ardoqStudio/viewPaneHeader$';
import { VIEW_PANE_BAR_HEIGHT, VIEW_PANE_BAR_PADDING } from './consts';
import { ViewpointToolBar } from 'canvas/contextToolBar/viewpointToolBar/ViewpointToolBar';
import { FlexBox } from '@ardoq/layout';
import { space } from '@ardoq/design-tokens';
import { ConnectedAiDraftMarker } from 'appLayout/viewAiBar/AiDraftMarker';

const HeaderContainer = styled.div<{
  $isFullWidth?: boolean;
}>`
  top: 0;
  display: flex;
  justify-content: space-between;
  user-select: none;
  margin: ${VIEW_PANE_BAR_PADDING}px;
  height: ${VIEW_PANE_BAR_HEIGHT}px;
  min-width: max-content;
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};
`;

const LeftGroup = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  grid-auto-columns: minmax(${space.xlarge}, max-content);
  align-items: center;
  gap: ${space.small};
`;

const ViewPaneHeader = (props: ViewPaneHeaderProps) => {
  // KFQ12026
  if (props.isCanvasPrototype) {
    return (
      <FlexBox
        align="center"
        justify="space-between"
        paddingY="small"
        paddingX="large"
        backgroundColor="bgSubtle"
        borderColor="borderSubtle"
        borderWidthBottom={1}
      >
        <LeftGroup>
          <ViewPaneHeaderLeftControls {...props} />
          <ConnectedAiDraftMarker />
        </LeftGroup>
        <ViewpointToolBar />
        <ViewPaneHeaderRightControls {...props} />
      </FlexBox>
    );
  }
  return (
    <HeaderContainer $isFullWidth={props.isFullWidth}>
      <ViewPaneHeaderLeftControls {...props} />
      <ViewPaneHeaderRightControls {...props} />
    </HeaderContainer>
  );
};

const ConnectedViewPaneHeader = connect(ViewPaneHeader, viewPaneHeader$);
export { ConnectedViewPaneHeader };
